import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const TermsOfService = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom fontWeight={700}>Terms of Service</Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        By using this website and placing orders, you agree to the terms below.
      </Typography>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Use of Service</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You agree not to misuse the platform, infringe intellectual property, or upload unlawful content.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Custom Content Responsibility</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You confirm you have rights to any images or text uploaded for product creation. We reserve the right to refuse orders that violate policies or laws.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Order & Fulfilment</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Orders enter production after payment and required inputs are received. Production or shipping delays due to factors outside our control (courier issues, supply disruptions) do not constitute breach.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Payments & Pricing</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Prices may change without prior notice. Orders already placed are charged at the confirmed checkout price.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Intellectual Property</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          All platform content (excluding user submissions) is owned by The Random Store and protected by applicable IP laws.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Limitation of Liability</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          We are not liable for indirect or consequential damages. Total liability is limited to the order value in dispute.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Policy & Terms Changes</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          We may update terms or policies. Continued use after changes implies acceptance.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Contact</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          For legal or compliance queries, email legal@therandomstore.com.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
